




















# import settings from '@/settings'
import n from '@/utils/notifications'
import q from '@/graphql/query'
import menus from '@/components/menus'

export default {
    name: 'distributor_stats'
    components: {
        menus
    }
    data: ()->
        self = @
        return {
            chart_options: {
                series: [],
                plotOptions: {
                    series: {
                        cursor: 'pointer',
                        marker: {
                            lineWidth: 1
                        },
                        point: {
                            events: {
                                click: (e)->
                                    self.update_datas(e.point.index)
                            }
                        }
                    }
                },
                legend: false,
                title: false,
                yAxis: {
                    title: {
                        text: 'Utilisations'
                    }
                },
                xAxis: {
                    categories: []
                }
            }
            back_button: false
            stats: []
            datas: []
            categories: []
            months_labels: ['janv', 'fevr', 'mars', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc']
        }

    watch:
        datas: (value)->
            # console.log "DATAS CHANGED", value
            @chart_options.series = [{name:'Utilisations', data: value}]
        categories: (value)->
            # console.log "CATEGORIES CHANGED", value
            @chart_options.xAxis.categories = value

    methods:
        go_back: ()->
            self = @
            @back_button = false
            @datas = @stats.map (x)-> x.count
            @categories = @stats.map (x)->
                self.months_labels[(x.month)-1]+" "+x.year

        update_datas: (index)->
            @back_button = true
            days = @stats[index].days
            @datas = days.map (x)-> x.count
            @categories = days.map (x)-> x.day
            # console.log "EVENT ", @datas
            # console.log "EVENT ", @categories

        get_stats: ()->
            self = @
            q.run('get_user_presence_stat')
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("distributor_stats: get_stats: then", e.message)
                else
                    # console.log "RUN QUERY STAT : ", resp.body.data.user_presence_stat
                    self.stats = resp.body.data.user_presence_stat
                    self.datas = self.stats.map (x)-> x.count
                    self.categories = self.stats.map (x)->
                        self.months_labels[(x.month)-1]+" "+x.year
                    # console.log "STATS CATEGORIES ", self.categories
            .catch (resp)->
                n.catch_error(resp, "distributor_stats: get_stats()")

    beforeMount: ()->
        @get_stats()
}
